import { render } from "./InputSearch.vue?vue&type=template&id=c1a2a5fe&ts=true"
import script from "./InputSearch.vue?vue&type=script&lang=ts"
export * from "./InputSearch.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__